import { isRSAA, RSAA } from 'redux-api-middleware';

const createApiHeaderMiddleware = (getClientContext) => (store) => (next) => (action) => {
	if (!isRSAA(action)) {
		return next(action);
	}

	const clientContext = getClientContext(store.getState(), action);

	const nextAction = {
		[RSAA]: {
			...action[RSAA],
			headers: {
				'x-bpi-service-context': 'USER',
				'Content-Type': 'application/json',
				'X-TS-AJAX-Request': true,
				'x-bpi-client-context': process.env.NODE_ENV === 'development' ? JSON.stringify(clientContext) : clientContext,
				...action[RSAA].headers,
			},
		},
	};
	return next(nextAction);
};

export default createApiHeaderMiddleware;
